import React from "react";

export const BackgroundDialogContext = React.createContext(null);
